import React from "react";
import { Route, Routes } from "react-router-dom";
import { XeroAndMyObList } from "./containers";

export const Xero = () => {
  return (
    <Routes>
      <Route path="/" element={<XeroAndMyObList />} />
    </Routes>
  );
};
